// biome-ignore lint/suspicious/noEmptyBlockStatements :[AUTOMATICALLY-INSERTED] Unexpected empty block.
export const noop = (): void => {};
